/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".col[_ngcontent-%COMP%]{width:50%!important}.item[_ngcontent-%COMP%]   angular-jazzicon[_ngcontent-%COMP%]{width:50px;height:50px}.event__content[_ngcontent-%COMP%]{padding-top:8px;padding-bottom:8px}.button__title[_ngcontent-%COMP%]{margin-left:5px}.qrcode-content[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}"];
export { styles as styles };
